import React from "react";

const SectionCard = ({ title, subtitle, action, children }) => {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4">
      <div className="mb-3 flex items-center justify-between">
        <div>
          <div className="font-semibold text-gray-900">{title}</div>
          {subtitle ? (
            <div className="text-[13px] text-gray-500">{subtitle}</div>
          ) : null}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
};

export default SectionCard;


